import OadpDatePicker2 from './oadp-date-picker2';
export default OadpDatePicker2;
